import { scrollDownWithUser } from '../../../assets/js/global/helpers';

const benefitsToYou = {
    init() {
        const lightbulb = document.getElementById('lightbulb');

        if (lightbulb) {
            scrollDownWithUser(document.getElementById('lightbulb'), 0, 798, true);
        }
    }
}

benefitsToYou.init();